var _g, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7794_57141)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E1E6F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.1357,
    y: 6.39514,
    width: 1.08,
    height: 2.592,
    rx: 0.54,
    fill: "#4611A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8106 12.7525C15.2625 11.9661 14.4153 11.4567 13.4805 11.3514C12.5458 11.2464 11.6117 11.5554 10.9115 12.2015C10.2112 12.8476 9.81099 13.7697 9.81055 14.7379C9.81055 17.639 13.0672 20.0778 15.4464 21.8587L15.8105 22.1313L16.1747 21.8587C18.5541 20.0779 21.8105 17.6389 21.8105 14.7379C21.8101 13.7698 21.4099 12.8477 20.7096 12.2015C20.0094 11.5555 19.0753 11.2464 18.1405 11.3514C17.2058 11.4566 16.3588 11.9661 15.8106 12.7525Z",
    fill: "#4611A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2081,
    y: 18.4768,
    width: 1.08,
    height: 2.592,
    rx: 0.54,
    transform: "rotate(-90 24.2081 18.4768)",
    fill: "#4611A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.20026,
    y: 18.9093,
    width: 1.08,
    height: 2.592,
    rx: 0.54,
    transform: "rotate(-90 5.20026 18.9093)",
    fill: "#4611A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3224,
    y: 23.4426,
    width: 1.08,
    height: 2.592,
    rx: 0.54,
    transform: "rotate(45 12.3224 23.4426)",
    fill: "#4611A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7682,
    y: 8.83063,
    width: 1.08,
    height: 2.592,
    rx: 0.54,
    transform: "rotate(45 23.7682 8.83063)",
    fill: "#4611A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.08,
    height: 2.592,
    rx: 0.54,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 8.64868 11.4274)",
    fill: "#4611A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.08,
    height: 2.592,
    rx: 0.54,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 20.094 26.0393)",
    fill: "#4611A7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7794_57141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.ddd44d9931cb8fc5ad8b58b53959ce64.svg";
export { ForwardRef as ReactComponent };